import { Camera, Compass, Code2 } from "lucide-react";

/**
 * Central data source for all services.
 * Used by both the Services overview cards and the dedicated detail pages.
 */
export const SERVICES = [
  {
    slug: "content-creation",
    icon: Camera,
    title: "Content Creation",
    desc: "Reels, Shorts, Foto- und Designcontent, der nicht nach Stock aussieht. Auf Wunsch übernehmen wir auch das Posting und Community-Management komplett.",
    points: ["Reels & Shorts Produktion", "Foto & Design", "Posting & Community Management (optional)"],
    seo: {
      title: "Content Creation Hamburg – Reels, Foto & Community Management | Hype Hafen",
      description:
        "Wir produzieren Reels, Shorts, Foto- und Design-Content für Marken aus Hamburg. Auf Wunsch übernehmen wir Posting und Community-Management deiner Kanäle komplett.",
    },
    detail: {
      eyebrow: "Leistung 01",
      headline: "Content Creation",
      sub: "Content, der nicht wie 100 andere aussieht. Wir produzieren vor Ort oder im Studio – und übernehmen auf Wunsch das komplette Hosting deiner Kanäle.",
      forWhom:
        "Für Unternehmen, die wissen, dass schwacher Content selbst die beste Strategie kaputt macht. Du brauchst Bildwelten, die nach deiner Marke aussehen – und keine Zeit, dich selbst um Posting und Kommentare zu kümmern.",
      sections: [
        {
          title: "Was wir produzieren",
          items: [
            "Reels & TikToks: Konzept, Skript, Hooks, Dreh, Schnitt, Sounds, Untertitel",
            "Foto-Content: Produkt-Shots, Behind-the-Scenes, Team & Branding",
            "Design-Assets: Karussell-Posts, Story-Templates, Highlight-Covers",
            "Voice-Over, Musik-Kuration und Sound-Design",
            "Optimierung pro Plattform (vertikales Format, Cover, Cropping)",
          ],
        },
        {
          title: "Optionale Zusatzleistungen",
          items: [
            "Hosting deiner Kanäle: Wir übernehmen das Posten zur richtigen Zeit auf Instagram, TikTok & Co.",
            "Community Management: DMs, Kommentare und Anfragen werden in deinem Tone-of-Voice beantwortet",
            "Redaktionsplanung: monatlicher Content-Plan, abgestimmt auf deine Themen",
            "Monatliches Reporting mit konkreten Learnings und Optimierungen",
          ],
        },
        {
          title: "So läuft ein Dreh ab",
          items: [
            "Vor-Briefing: Wir bringen Skripte mit, du musst nichts vorbereiten",
            "Dreh vor Ort (Hamburg & Umgebung) oder remote-Produktion",
            "Lieferung der ersten Edits innerhalb von 5-7 Tagen",
            "Eine Korrekturschleife inklusive – passgenau ohne Endloskorrekturen",
          ],
        },
      ],
      idealIf: [
        "Deine Posts performen schlecht, weil das Visuelle nicht überzeugt",
        "Du willst deinen Auftritt sofort professioneller aussehen lassen",
        "Du suchst jemanden, der dir Content abnimmt und ihn auch postet",
      ],
    },
  },
  {
    slug: "beratung-strategie",
    icon: Compass,
    title: "Beratung & Strategie",
    desc: "Positionierung, Markenidentität, Tone-of-Voice und Content-Strategie. Wir schärfen, was deine Marke ausmacht – damit sie an Land geht, nicht im Feed ertrinkt.",
    points: ["Positionierung", "Visual Identity", "Content-Strategie"],
    seo: {
      title: "Social Media Strategie & Markenberatung Hamburg | Hype Hafen",
      description:
        "Positionierung, Markenidentität, Tone-of-Voice und Content-Strategie. Wir schärfen, wofür deine Marke steht – inklusive 3–6-Monats-Content-Fahrplan zur Umsetzung.",
    },
    detail: {
      eyebrow: "Leistung 02",
      headline: "Beratung & Strategie",
      sub: "Bevor wir posten oder bauen, schärfen wir, wofür du stehst. Klare Positionierung, eigene Bildsprache und eine Content-Strategie, die zu deinen Zielen passt.",
      forWhom:
        "Für Gründer:innen und Marken, die merken: „Wir sehen aus wie alle anderen.“ Du brauchst kein Logo-Refresh – du brauchst eine Position, die sticht und eine Strategie, die du wirklich umsetzen kannst.",
      sections: [
        {
          title: "Was im Strategie-Workshop passiert",
          items: [
            "Positionierungs-Analyse: Wer bist du, für wen, gegen wen?",
            "Markenversprechen & Kern-Botschaften in 3 klaren Sätzen",
            "Visual Identity: Farben, Schriften, Bildwelten – konsistent durchgezogen",
            "Tone-of-Voice: Wie sprichst du? Wie nicht?",
            "Content-Strategie: Welche Formate auf welcher Plattform und in welcher Frequenz",
          ],
        },
        {
          title: "Was du danach hast",
          items: [
            "Eine klare Antwort auf „Was machen wir, was die anderen nicht machen?“",
            "Einen konkreten Content-Fahrplan für die nächsten 3-6 Monate",
            "Ein Marken-Set, mit dem dein Team und Freelancer arbeiten können",
            "Ein Fundament, auf dem Content & Marketing wirklich aufbaut",
          ],
        },
      ],
      idealIf: [
        "Du startest eine Marke und willst von Anfang an sauber aufgestellt sein",
        "Deine Botschaft verwässert sich von Post zu Post",
        "Du planst einen Relaunch oder eine neue Linie",
      ],
    },
  },
  {
    slug: "webseiten-erstellung",
    icon: Code2,
    title: "Webseiten Erstellung",
    desc: "Wir bauen Webseiten, die mehr sind als digitale Visitenkarten: schnell, sauber gecodet und im Look deiner Marke. Auf Wunsch übernehmen wir auch Hosting und Wartung.",
    points: ["Website & Landingpages", "Responsive Design", "Hosting & Wartung (optional)"],
    seo: {
      title: "Webseite erstellen lassen Hamburg – schnell, DSGVO-konform | Hype Hafen",
      description:
        "Wir bauen schnelle, sauber gecodete Webseiten und Landingpages – Mobile-First, SEO-Grundsetup, DSGVO-konform. Optional inklusive Hosting, Domain und laufender Pflege.",
    },
    detail: {
      eyebrow: "Leistung 03",
      headline: "Webseiten Erstellung",
      sub: "Deine Webseite ist oft der erste echte Berührungspunkt mit deiner Marke. Wir bauen sie schnell, sauber und so, dass sie deine Sichtbarkeit aktiv unterstützt – inklusive optionalem Komplett-Service für Hosting & Pflege.",
      forWhom:
        "Für Selbstständige und Unternehmen, die eine moderne Webseite brauchen – ohne Wordpress-Frickelei, ohne Plugin-Chaos und ohne Agentur-Aufschlag.",
      sections: [
        {
          title: "Was wir bauen",
          items: [
            "One-Pager wie diese hier – ideal für klare Botschaft & Lead-Generierung",
            "Landingpages für einzelne Angebote, Kampagnen oder Launches",
            "Mehrseitige Webseiten mit Kontaktformular, Blog, Galerie",
            "Mobile-First-Design: sieht auf Smartphone genauso gut aus wie am Desktop",
            "SEO-Grundsetup: Title, Meta, OG-Tags, Sitemap – auffindbar von Tag 1",
          ],
        },
        {
          title: "Zwei Hosting-Optionen – du entscheidest",
          items: [
            "Selbst-Hosting: Wir übergeben dir alle Dateien, du hostest auf deiner eigenen Plattform (z. B. Vercel, Netlify). Anleitung inklusive.",
            "Komplettpaket: Wir übernehmen das Hosting, die Domain-Verwaltung, regelmäßige Updates und die laufende Pflege – du musst dich um nichts kümmern.",
            "Beide Optionen sind nachträglich wechselbar – z. B. erst Komplettpaket, später Übergabe ans eigene Team.",
          ],
        },
        {
          title: "Technisch sauber",
          items: [
            "Schnelle Ladezeiten – kein Theme-Ballast",
            "DSGVO-konform aufgesetzt (Impressum, Datenschutz, Cookie-frei wenn möglich)",
            "Eigene Domain & HTTPS inklusive",
            "Auf Wunsch: monatliche Wartung, Backups, Inhalts-Updates",
          ],
        },
      ],
      idealIf: [
        "Deine aktuelle Seite ist langsam, alt oder peinlich",
        "Du brauchst schnell eine Landingpage für eine Kampagne",
        "Du willst eine moderne Webseite, ohne dich um Technik & Hosting zu kümmern",
      ],
    },
  },
];

export const getServiceBySlug = (slug) => SERVICES.find((s) => s.slug === slug);
